export const validNumericRegex = /^[0-9]+$/;
export const validAlphaNumericRegex = /^[a-zA-Z0-9- äöüÄÖÜß]+$/;
//# sourceMappingURL=validRegex.js.map